const messages = {
  payoutsDescription: "List of paid out BS+ items.",
  paidOut: "paid out",
  makeChoice: "Vyberte si tu.",
  seeAll: "Zobraziť všetko",
  clear: "Vyčistiť",
  back: "Späť",
  save: "Uložiť",
  close: "Zatvoriť",
  of: "z",
  to: "do",
  copyrights: "© {date} Bridgestone Solutions. Všetky práva vyhradené.",
  pageNotFound: "Stránka nebola nájdená",
  accessDenied: "Prístup zamietnutý",
  search: "Hľadať",
  year: "Rok",
  buttons: {
    loading: "Načítava sa...",
    export: "Exportovať",
    delete: "Vymazať",
    save: "Uložiť",
    cancel: "Zrušiť",
    next: "Ďalej",
    back: "Späť",
    skip: "Preskočiť",
    send: "Odoslať",
    readNow: "Přečtěte si nyní",
    clear: "Vyčistiť",
    more: "Viac",
    close: "Zatvoriť",
    reportError: "Nahlásiť chybu",
    accept: "Prijať",
    download: "Stiahnuť",
    downloadAll: "Stiahnuť všetko",
    selectAll: "Vybrať všetko",
    deselectAll: "Zrušiť výber",
    downloadSelection: "Stiahnuť vybrané",
    dealerInfoDownload: "Stiahnuť",
    toTheBasket: "Do košíka",
    toOrderDelivery: "Pokračovať na doručovaciu adresu",
    discover: "Objaviť",
    newAddress: "Vytvoriť novú doručovaciu adresu",
    selectAddressBtn: "Vybrať doručovaciu adresu",
    toOrderSummary: "K prehľadu objednávky",
    placeOrder: "Záväzná objednávka",
    toDashboard: "Na domovskú stránku",
    newOrder: "Nová objednávka",
    userOrders: "K vašim objednávkam",
    toSearch: "Hľadať",
    select: "Vybrať",
    moreCustomerNumbers: "+ PRIDAŤ ĎALŠIE ZÁKAZNÍCKE ČÍSLA",
    pointsList: "Zoznam bodov",
    loadMore: "Načítať viac",
    toStaffDashboard: "Na panel",
    toQuiz: "Ku kvízu",
    vouchers: "Poukazy",
    exchangeVoucher: "Uplatniť kód poukazu",
    confirm: "Potvrdiť",
    sharePoints: "Zdieľať body",
    create: "Vytvoriť",
    update: "Aktualizovať",
    toBDrive: "Do B-Drive",
    preview: "Náhľad",
    clickHere: "Zobraziť podrobnosti",
    setFilters: "Nastavte prosím <b>maximálne jeden filter na stĺpec</b>",
    all: "Všetko",
  },
  tooltips: {
    info: "Potrebujete pomoc? +421 905 306 674",
  },
  confirmation: {
    header: "Vyžaduje sa potvrdenie",
    message: "Chcete túto položku vymazať?",
  },
  nav: {
    consents: "Súhlasy",
    dashboard: "Domov",
    accountDashboard: "Prehľad",
    account: "Môj Profil",
    mailbox: "VAŠE ZPRÁVY",
    singleMailbox: "Správy",
    stammdaten: "Profil",
    news_feeds: "Správy",
    pointsOverview: "Prehľad bodov",
    rewardsOverview: "Prehľad bodov",
    about: "O BS Plus",
    service_number: "Kontakt na servis",
    shop: "Obchod s odmenami",
    salesPromotions: "Predajné akcie",
    promotions: "Môj účet",
    shopCategory: "Obchod s odmenami",
    productDetails: "Detaily produktu",
    userOrders: "Používateľské objednávky",
    shoppingCart: "Nákupný košík",
    orderDelivery: "Doručovacia adresa",
    orderSummary: "Prehľad objednávky",
    orderComplete: "Objednávka dokončená",
    text_page: "Statická stránka",
    staff: "Servisný panel",
    onlineTrainings: "Online školenia",
    trainings: "Školenia",
    training: "Školenie",
    trainingForm: "Formulár školenia",
    staffVouchers: "Poukazy",
    wholesalerVouchers: "Poukazy",
    brochure_prices: "Cenníky a brožúry",
    investment: "Podpora investicii",
    media: "Médiá",
    medias: "Médiá",
    contact_service: "Kontaktné údaje a servis",
    productInfo: "INFORMÁCIE O PRODUKTE",
    bDrive: "Obrázky produktov",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Podmienky účasti",
    first_stop: "Záruka na pneumatiky Bridgestone",
    payouts: "Payouts",
    bonusUhrd: "Bonus UHRD",
    bonusGoals: "Nákupné ciele",
    bonusAwans: "BONUS ZA POSTUP",
    portalPromotions: "Akcie",
    portalPromotionDetail: "Detail akcie",
  },
  breadcrumbs: {
    dashboard: "Domov",
    accountDashboard: "Prehľad",
    account: "Môj Profil",
    mailbox: "VAŠE ZPRÁVY",
    singleMailbox: "Správy",
    stammdaten: "Profil",
    news_feeds: "Správy",
    pointsOverview: "Prehľad bodov",
    rewardsOverview: "Prehľad bodov",
    about: "O BS Plus",
    service_number: "Kontakt na servis",
    shop: "Obchod s odmenami",
    salesPromotions: "Predajné akcie",
    promotions: "Môj účet",
    shopCategory: "Obchod s odmenami",
    productDetails: "Detaily produktu",
    userOrders: "Používateľské objednávky",
    shoppingCart: "Nákupný košík",
    orderDelivery: "Doručovacia adresa",
    orderSummary: "Prehľad objednávky",
    orderComplete: "Objednávka dokončená",
    staff: "Servisný panel",
    onlineTrainings: "Online školenia",
    trainings: "Školenia",
    training: "Školenie",
    trainingForm: "Formulár školenia",
    staffVouchers: "Poukazy",
    wholesalerVouchers: "Poukazy",
    brochure_prices: "Cenníky a brožúry",
    investment: "Podpora investicii",
    media: "Médiá",
    medias: "Médiá",
    contact_service: "Kontaktné údaje a servis",
    productInfo: "INFORMÁCIE O PRODUKTE",
    bDrive: "Obrázky produktov",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Podmienky účasti",
    first_stop: "Záruka na pneumatiky Bridgestone",
    payouts: "Payouts",
    portalPromotions: "Akcie",
    portalPromotionDetail: "Detail akcie",
  },
  menu: {
    account: "Môj Profil",
    plus: 'O Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Podpora predaja",
    mailbox: "VAŠE ZPRÁVY",
    about: "O BS Plus",
    trainingAndCourses: "Školenia a kurzy",
    externalTraining: "Externé školenie",
    productInfo: "Informácie o produktoch",
    productBrochures: "Produktové brožúry",
    priceLists: "Cenníky",
    price: "Cena",
    complaintForm: "Formulár sťažnosti",
    sales_support: "Podpora predaja",
    contact_service: "Kontaktné údaje a servis",
    logOut: "Odhlásiť sa",
    news: "Novinky",
    news_feeds: "Správy",
    service_number: "Kontakt na servis",
    salesPromotions: "Predajné akcie",
    shop: "Obchod",
    onlineTrainings: "Online školenia",
    trainings: "Školenia",
    brochure_prices: "Cenníky a brožúry",
    media: "Médiá",
    medias: "Médiá",
    stammdaten: "Profil",
    preislisten: "Cenníky",
  },
  validation: {
    requiredField: "Povinné pole",
  },
  sortBy: {
    default: "Zoradiť podľa",
    desc: "Zoradiť podľa: Najnovšie",
    asc: "Zoradiť podľa: Najstaršie",
    name: "Názov",
    date: "Dátum",
    choiceBy: "Triediť",
  },
  month: {
    1: "január",
    2: "február",
    3: "marec",
    4: "apríl",
    5: "máj",
    6: "jún",
    7: "júl",
    8: "august",
    9: "september",
    10: "október",
    11: "november",
    12: "december"
  },
};


export default {
  messages,
};
